import React from "react";
import "./Hero.css";

const Hero = ({ heroInfo }) => {
  if (!heroInfo) return null;

  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">{heroInfo.fullName}</h1>
          <h2 className="hero-subtitle">{heroInfo.title}</h2>
          <p className="hero-description">{heroInfo.description}</p>
        </div>
      </div>
    </section>
  );
};

export default Hero;
